module.exports = __webpack_public_path__ + "static/media/audioFilesSeUpperGradesSound.69b50d6c.mp3";